import React from 'react';

export default function RichResourceIcon({ width = 17, height = 16 }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.43243 1.48041C2.34961 0.532519 3.59356 0 4.89064 0H16.3021C16.7345 0 17.1491 0.177506 17.4549 0.49347L28.8663 12.2872C29.1721 12.6031 29.3438 13.0317 29.3438 13.4785V32.0114C29.3438 33.352 28.8286 34.6376 27.9114 35.5855C26.9942 36.5334 25.7503 37.0659 24.4532 37.0659H4.89064C3.59356 37.0659 2.34961 36.5334 1.43243 35.5855C0.515262 34.6376 0 33.352 0 32.0114V5.05444C0 3.71392 0.515262 2.4283 1.43243 1.48041ZM4.89064 3.36962C4.45828 3.36962 4.04363 3.54713 3.7379 3.86309C3.43218 4.17906 3.26042 4.6076 3.26042 5.05444V32.0114C3.26042 32.4583 3.43218 32.8868 3.7379 33.2028C4.04363 33.5187 4.45828 33.6962 4.89064 33.6962H24.4532C24.8855 33.6962 25.3002 33.5187 25.6059 33.2028C25.9116 32.8868 26.0834 32.4583 26.0834 32.0114V14.1764L15.6269 3.36962H4.89064Z"
        fill="white"
      />
      <path
        d="M3.7379 3.86309C4.04363 3.54713 4.45828 3.36962 4.89064 3.36962H15.6269L26.0834 14.1764V32.0114C26.0834 32.4583 25.9116 32.8868 25.6059 33.2028C25.3002 33.5187 24.8855 33.6962 24.4532 33.6962H4.89064C4.45828 33.6962 4.04363 33.5187 3.7379 33.2028C3.43218 32.8868 3.26042 32.4583 3.26042 32.0114V5.05444C3.26042 4.6076 3.43218 4.17906 3.7379 3.86309Z"
        fill="white"
      />
      <path
        d="M16.3021 0C17.2024 0 17.5347 0.28749 18.489 1.27372L23.2603 6.20488L28.0317 11.136C28.9859 12.1223 29.3438 12.548 29.3438 13.4785C29.3438 14.409 28.6139 15.1633 27.7136 15.1633H16.3021C15.4017 15.1633 14.6719 14.409 14.6719 13.4785V1.68481C14.6719 0.754316 15.4017 0 16.3021 0Z"
        fill="#DEDEDE"
      />
    </svg>
  );
}
